// extracted by mini-css-extract-plugin
export var button = "styles-module--button--05e35";
export var dark = "styles-module--dark--8ed8f";
export var desktop = "styles-module--desktop--82422";
export var items = "styles-module--items--7cdbe";
export var light = "styles-module--light--adb26";
export var mobile = "styles-module--mobile--feda8";
export var panel = "styles-module--panel--93be4";
export var wrapper = "styles-module--wrapper--a6f97";